/*
window.addEventListener('message', e => {
    const { event, ...rest } = e.data;
    console.log(`event: ${event}, data:`, rest);
})
*/

function init_multi_characters_dates()
{   
    const input_holder = document.querySelector("input[name='properties[__Character Holder]']")
    
    // break if not required
    if( input_holder == null ) return false;
    
    //const original_options_holder = document.querySelector('div.custom-message')
  	 // make sure it's the last one
     const custom_messages = document.querySelectorAll('div.custom-message')
     const original_options_holder = custom_messages[custom_messages.length- 1]
  
    const block_holder = document.getElementById("detailWrapper")

    //add initial button
    let add_slot_button = document.createElement("button")
        add_slot_button.innerHTML = "+ Add Another Birthday Reminder"
        add_slot_button.classList = "add_slot_button"
        add_slot_button.onclick = function()
        {
            add_slot(true)
            connect_datepickers()
            return false
        }

    //slot holder
    let slot_holder = document.createElement("div")
        slot_holder.classList = "slot_holder"

    //block title
    let block_title = document.createElement("h4")
        block_title.classList = "block_title"
        block_title.innerHTML = "Personalise the front of the diary"

    //slot title
    let holder_title = document.createElement("h4")
        holder_title.classList = "slots_title"
        holder_title.innerHTML = "Add Birthday Reminders"

    let holder_desc = document.createElement("p")
        holder_desc.classList = "slots_desc"
        holder_desc.innerHTML = "Add your friend's character and DOB to the diary so you never forget their all-important birthday."

    // character_1 choiceURL storage
    // the page gets confused when you you create a slot character first, this is used to store the default character_1 for that
    // let default_character_storage = document.createElement("input")
    //     default_character_storage.setAttribute('type', 'hidden')
    //     default_character_storage.id = "default_character_storage";

	if( document.querySelector('h1.product-detail__title').innerText.indexOf('Diary') != "-1" )
    {
      block_holder.prepend(block_title)
    }
    original_options_holder.appendChild(holder_title)
    original_options_holder.appendChild(holder_desc)
    original_options_holder.appendChild(slot_holder)
    original_options_holder.appendChild(add_slot_button)
    // original_options_holder.appendChild(default_character_storage)

    // First Slot
    add_slot(false)
    connect_datepickers()

    //add to cart data collection
    document.getElementById("add-to-cart").addEventListener('click',function ( e ){
        store_slot_data()
    })
    
    setInterval(store_slot_data, 350)
    
    //also just call this every 1/3 second to prevent gaps
    function store_slot_data()
    {
       let slot_data = collect_slot_data()
       input_holder.value = JSON.stringify(slot_data)
       //console.log(slot_data)
    }

    // catching builder events
    window.addEventListener('message', e => {
        if (event.data.hasOwnProperty('event')) {
            switch (event.data.event) {

                case 'store':
                    let { key, brand } = event.data.data

                    let slot_config = slot_fetch_config(key)
                    slot_update_preview(key, slot_config)
                    slot_toggle_buttons(key)

                    //put the default character back in choiceURL - to stop is breaking...
                    // let default_character = document.getElementById('default_character_storage').val
                    // window.store.choiceUrl = default_character

                    break
            }
        }
    })

    function slot_fetch_config(key)
    {
        let midnightConfig = document.getElementsByName('properties[__midnight_config]')[0].value
        let configObject = JSON.parse(midnightConfig)
        return configObject[key]
    }

    function collect_slot_data()
    {
        let slot_data = {}
        let slots = [ ...document.querySelectorAll('div.slot_wrapper')]

        let needs_alert = false

        slots.forEach( slot => {
            let key = slot.dataset.name
            let name = slot.querySelector('input.name').value
            let date = slot.querySelector('input.datepicker').value
            let character = slot.querySelector('input.character_input').value

            //validation
            if( key != "slot_1" && ( name == "" || date == "" || character == "" ) )
            {
                needs_alert = true
            }

            slot_data[ key ] = {
                name: name,
                date: date,
                character: character
            }
        })

        // if( needs_alert ) alert("Please make sure each character has a Name & Birthday")

        return slot_data
    }


    function add_slot( is_required )
    {
        let slot_count = [...document.querySelectorAll('div.slot_wrapper')].length
        let new_slot_id = slot_count + 1;

        const character_key = 'slot_' + new_slot_id;

        let wrapper = document.createElement("div")
            wrapper.className = "slot_wrapper"
            wrapper.dataset.name = character_key

        let preview = document.createElement("img")
            preview.setAttribute("name", "preview_" + character_key)
            preview.className = "slot_preview"
            preview.setAttribute("src","https://cdn.shopify.com/s/files/1/0167/0217/7380/files/diary_ghost.png?v=1636040132")

        let character_input = document.createElement("input")
            character_input.className = "character_input"
            character_input.setAttribute('name', 'character_' + character_key)
            character_input.setAttribute('type', 'hidden')
            if( is_required ) character_input.setAttribute('required', true)

        let create_button = document.createElement("button")
            create_button.setAttribute("name", "create_" + character_key)
            create_button.setAttribute("type","button")
            create_button.classList = ["create_button"]
            create_button.innerHTML = "Create Character"
            create_button.onclick = async function()
            {

                //check to see if character1 has been picked yet - if not, break
                //because it won't work after another slot character has been set
                // - cant find a better way to check if character1 has been picked yet...
                if( document.getElementById('character-preview') )
                {
                    //not done character1 yet...
                  	if( document.getElementById('character-preview').src.split("_").length < 5 )
                    {
                      alert("Please make your front character before the inside characters")
                      return false
                    }
                }

                //create character
//                 let queryData = { key: character_key }
	            let queryData = { key: character_key, tag: "family_no_baby" }
                let builderUrl = `${globalMoonshineBaseUrl}${encodeQueryString(queryData)}`
              
//               	let builderUrl = `${globalMoonshineBaseUrl}/?screen=selector&key=${character_key}&tag=one_human`

                document
                    .getElementById('builder')
                    .contentWindow.location.replace(builderUrl)

                await new Promise((r) => setTimeout(r, 500))

                //show builder
                window.windowScrollPosition = $(window).scrollTop()
                $('html, body').addClass('noScroll')
                toggleBuilderWindow('flex')
                $('.breadcrumbs').css('z-index', 1)
                $('.site-header').css('z-index', 1)
                $('body').css('height', '100%')
                $('body').css('overflow', 'hidden')


                //store default character1
                // let default_character = JSON.parse(sessionStorage.character1).character
                // document.getElementById('default_character_storage').val = default_character

                return false
            }
      
        // let load_button = document.createElement("button")
        //     load_button.setAttribute("name", "load_" + character_key)
        //     load_button.setAttribute("type","button")
        //     load_button.classList = ["load_button"]
        //     load_button.innerHTML = "Load Character"
        //     load_button.onclick = async function()
        //     {
        //       let config = characterStorage.getMoonshineConfig()
        //       let queryData = { screen: 'selector', key: character_key }
        //       let builderUrl = `${globalMoonshineBaseUrl}${encodeQueryString(queryData)}`

        //       document
        //         .getElementById('builder')
        //         .contentWindow.location.replace(builderUrl)

        //       await new Promise((r) => setTimeout(r, 500))
              
        //       let characters = characterStorage.getAllCharacters()

        //       let contentWindow = document.getElementById('builder').contentWindow

        //       contentWindow.postMessage(
        //         {
        //           event: 'characters',
        //           value: characters,
        //         },
        //         '*'
        //       )

        //       //show builder
        //       window.windowScrollPosition = $(window).scrollTop()
        //       $('html, body').addClass('noScroll')
        //       toggleBuilderWindow('flex')
        //       $('.breadcrumbs').css('z-index', 1)
        //       $('.site-header').css('z-index', 1)
        //       $('body').css('height', '100%')
        //       $('body').css('overflow', 'hidden')
        //     }

        let edit_button = document.createElement("button")
            edit_button.setAttribute("name", "edit_" + character_key)
            edit_button.setAttribute("type","button")
            edit_button.classList = ["edit_button hidden"]
            edit_button.innerHTML = "Edit Character"
            edit_button.onclick = async function()
            {
                let characterToEdit = JSON.parse(sessionStorage.getItem(character_key))
//                 let queryData = { key: character_key }
                let queryData = { key: character_key, tag: "family_no_baby" }
                let builderUrl = `${globalMoonshineBaseUrl}/${characterToEdit.brand}${encodeQueryString(queryData)}`

                //choiceUrl bug - explicitly set it to the 'to-edit' character
                window.store.choiceUrl = characterToEdit.character

                let contentWindow = document.getElementById('builder').contentWindow

                contentWindow.location.replace(builderUrl)

                await new Promise((r) => setTimeout(r, 500))

                let post = {
                    event: 'load',
                    key: 'character',
                    value: characterToEdit.character,
                }

                contentWindow.postMessage(post,'*')

                contentWindow.postMessage({ event: 'navigate', key: 'builder' }, '*')

                //show builder
                window.windowScrollPosition = $(window).scrollTop()
                $('html, body').addClass('noScroll')
                toggleBuilderWindow('flex')
                $('.breadcrumbs').css('z-index', 1)
                $('.site-header').css('z-index', 1)
                $('body').css('height', '100%')
                $('body').css('overflow', 'hidden')
                
                return false;
            }

        let name_input = document.createElement("input")
            name_input.className = "name"
            name_input.setAttribute('name', 'name_' + character_key)
            name_input.setAttribute('type', 'text')
            name_input.setAttribute('placeholder', 'Name')
            if( is_required ) name_input.setAttribute('required', true)
      
        let date_holder = document.createElement("input")
            date_holder.className = "datepicker"
            date_holder.setAttribute('name', 'date_' + new_slot_id)
            date_holder.setAttribute('type', 'text')
            if( is_required ) date_holder.setAttribute('required', true)
            date_holder.setAttribute('readonly', true)
            date_holder.setAttribute('placeholder', 'Select Birthday')

        // let title = document.createElement("span")
            // title.innerHTML = new_slot_id
            // title.classList = "slot_title"
            
            
        let remove_button = document.createElement("span")
            remove_button.setAttribute("name", "remove_" + character_key)
            remove_button.setAttribute("type","button")
            remove_button.classList = "remove_button"
            remove_button.innerHTML = "x"
            remove_button.onclick = async function()
            {
                let holder = [...document.querySelectorAll("[data-name='slot_"+new_slot_id+"']")][0];
                holder.remove();
                return false;
            }

        // wrapper.appendChild(title)
        wrapper.appendChild(preview)
        wrapper.appendChild(character_input)
        wrapper.appendChild(create_button)
        wrapper.appendChild(edit_button)
        // wrapper.appendChild(load_button)
        wrapper.appendChild(name_input)
        wrapper.appendChild(date_holder)
        wrapper.appendChild(remove_button)

        slot_holder.appendChild(wrapper)
    }

    function connect_datepickers()
    {
        function callback()
        {
          jQuery('div.slot_wrapper input.datepicker').each(function(){
            jQuery(this).datepicker({
              changeMonth: true,
              changeYear: true,
              minDate: new Date(1951, 1, 1), 
              maxDate: "+2Y",
              dateFormat: 'dd/mm/yy',
              yearRange: "-70:+2",
              onSelect: function(date){
                //check that no two dates are the same
                let unique = []
                jQuery('div.slot_wrapper input.datepicker').each(function(){
                  let date = jQuery(this).val()
                  
                  if( date.length == 0 ) return;
                  
                  if( unique.includes( date ) )
                  {
                    alert('Sorry - There is only room for one character per date')
                    jQuery(this).val("")
                    return
                  }
                  else
                  {
                    unique.push(date)
                  }
                });
              } 
            });
          });
        }

        if (window.jQuery.fn.datepicker) {
          callback();
        } else {
          var script = document.createElement('script');
          script.src = '//code.jquery.com/ui/1.10.2/jquery-ui.js';
          script.onload = callback;
          document.getElementsByTagName('head')[0].appendChild(script);
        }


    }

    function slot_toggle_buttons(key)
    {
        let edit_button = document.getElementsByName('edit_' + key)[0]
        let create_button = document.getElementsByName('create_' + key)[0]

        //only happens the first create
        if( edit_button.classList.contains("hidden") )
        {
            edit_button.classList.remove("hidden")
            create_button.classList.add("hidden")
        }
    }

    function slot_update_preview(key, config)
    {
      let imageParams = [
        config.image,
        config.pose_id,
        config.document_id,
        config.context_id,
      ].join('_')

      let previewUrl = "https://builder.midnightplatform.net/midnight/system/generate/" + imageParams + ".png"

      let preview_image = document.getElementsByName("preview_" + key)[0]
      preview_image.src = previewUrl
      // preview_image.dataset.image = config.image
      let character_input = document.getElementsByName("character_" + key)[0]
      character_input.value = config.image

      //if the character is set - make sure the name/date inputs are required (?)
      document.getElementsByName("name_" + key)[0].required = true
      let key_number = key.replace("slot_","")
      document.getElementsByName("date_" + key_number)[0].required = true
    }
}

//{"slot_1":{"name":"Green","date":"07/11/2021","character":"mrcb_v10_ST023_BT002_BH000_HC002_HS009_FH000_FHC000_EX001_EC001_EW000_EWC000_HW000_HWC000_LH000_AC000_OF007_OC031_FM000_FMC000_ET002_HL000_BR004_BRC001_MT004_LC001_FS005"},"slot_2":{"name":"Yellow","date":"12/11/2021","character":"claireabella-girls_v10_ST025_CS001_BT001_HC001_HS001_EX001_EC001_EW000_EWC000_HW000_HWC000_LH000_AC000_OF028_OC146_LC001_CC001_FM000_FMC000_ET001_EL005"}}

// <div class="slot_wrapper" data-name="slot_1">
//     <img name="preview_slot_1" class="slot_preview" src="https://builder.midnightplatform.net/midnight/system/generate/mrcb_v10_ST023_BT002_BH000_HC002_HS009_FH000_FHC000_EX001_EC001_EW000_EWC000_HW000_HWC000_LH000_AC000_OF007_OC031_FM000_FMC000_ET002_HL000_BR004_BRC001_MT004_LC001_FS005_PZ001_DC001_CX001.png" title="" style="">
//     <input class="character_input" name="character_slot_1" type="hidden" required="true" value="mrcb_v10_ST023_BT002_BH000_HC002_HS009_FH000_FHC000_EX001_EC001_EW000_EWC000_HW000_HWC000_LH000_AC000_OF007_OC031_FM000_FMC000_ET002_HL000_BR004_BRC001_MT004_LC001_FS005">
//     <button name="create_slot_1" type="button" class="create_button hidden">Create Character</button>
//     <button name="edit_slot_1" type="button" class="edit_button">Edit Character</button>
//     <input class="name" name="name_slot_1" type="text" placeholder="Name" required="true">
//     <input class="datepicker hasDatepicker" name="date_1" type="text" required="true" placeholder="Select Birthday" id="dp1636048471473">
//     <span name="remove_slot_1" type="button" class="remove_button">x</span>
// </div>

function hydrate_multi_characters_dates( data )
{
    let slots = JSON.parse(data)

    let slot_holder = document.querySelector("div.slot_holder")
    let input_holder = document.querySelector("input[name='properties[__Character Holder]']")

    //remove inital slot
    document.querySelector("div.slot_wrapper").remove()
    
    Object.entries(slots).forEach(item =>{
        const [character_key, slot] = item;

        let new_slot_id = character_key.replace("slot_","");

        let wrapper = document.createElement("div")
            wrapper.className = "slot_wrapper"
            wrapper.dataset.name = character_key

        let preview = document.createElement("img")
            preview.setAttribute("name", "preview_" + character_key)
            preview.className = "slot_preview"
            preview.setAttribute("src","https://builder.midnightplatform.net/midnight/system/generate/"+slot.character+"_PZ001_DC001_CX001.png")

        let character_input = document.createElement("input")
            character_input.className = "character_input"
            character_input.setAttribute('name', 'character_' + character_key)
            character_input.value = slot.character
            character_input.setAttribute('type', 'hidden')
            character_input.setAttribute('required', true)

        let edit_button = document.createElement("button")
            edit_button.setAttribute("name", "edit_" + character_key)
            edit_button.setAttribute("type","button")
            edit_button.classList = ["edit_button"]
            edit_button.innerHTML = "Edit Character"
            edit_button.onclick = async function()
            {
                let characterToEdit = JSON.parse(sessionStorage.getItem(character_key))
//                 let queryData = { key: character_key }
                let queryData = { key: character_key, tag: "family_no_baby" }
                let builderUrl = `${globalMoonshineBaseUrl}/${characterToEdit.brand}${encodeQueryString(queryData)}`

                //choiceUrl bug - explicitly set it to the 'to-edit' character
                window.store.choiceUrl = characterToEdit.character

                let contentWindow = document.getElementById('builder').contentWindow

                contentWindow.location.replace(builderUrl)

                await new Promise((r) => setTimeout(r, 500))

                let post = {
                    event: 'load',
                    key: 'character',
                    value: characterToEdit.character,
                }

                contentWindow.postMessage(post,'*')

                contentWindow.postMessage({ event: 'navigate', key: 'builder' }, '*')

                //show builder
                window.windowScrollPosition = $(window).scrollTop()
                $('html, body').addClass('noScroll')
                toggleBuilderWindow('flex')
                $('.breadcrumbs').css('z-index', 1)
                $('.site-header').css('z-index', 1)
                $('body').css('height', '100%')
                $('body').css('overflow', 'hidden')
                
                return false;
            }

        let name_input = document.createElement("input")
            name_input.className = "name"
            name_input.setAttribute('name', 'name_' + character_key)
            name_input.setAttribute('type', 'text')
            name_input.setAttribute('required', true)
            name_input.value = slot.name
      
        let date_holder = document.createElement("input")
            date_holder.className = "datepicker"
            date_holder.setAttribute('name', 'date_' + new_slot_id)
            date_holder.setAttribute('type', 'text')
            date_holder.setAttribute('required', true)
            date_holder.setAttribute('readonly', true)
            date_holder.value = slot.date
            
            
        let remove_button = document.createElement("span")
            remove_button.setAttribute("name", "remove_" + character_key)
            remove_button.setAttribute("type","button")
            remove_button.classList = "remove_button"
            remove_button.innerHTML = "x"
            remove_button.onclick = async function()
            {
                let holder = [...document.querySelectorAll("[data-name='slot_"+new_slot_id+"']")][0];
                holder.remove();
                return false;
            }

        // wrapper.appendChild(title)
        wrapper.appendChild(preview)
        wrapper.appendChild(character_input)
        wrapper.appendChild(edit_button)
        wrapper.appendChild(name_input)
        wrapper.appendChild(date_holder)
        wrapper.appendChild(remove_button)

        slot_holder.appendChild(wrapper)

    });

    connect_datepickers()

    //add to cart data collection
    document.getElementById("update").addEventListener('click',function ( e ){
        let slot_data = collect_slot_data()
        input_holder.value = JSON.stringify(slot_data)
    })

    function collect_slot_data()
    {
        let slot_data = {}
        let slots = [ ...document.querySelectorAll('div.slot_wrapper')]
        slots.forEach( slot => {
            let key = slot.dataset.name
            let name = slot.querySelector('input.name').value
            let date = slot.querySelector('input.datepicker').value
            let character = slot.querySelector('input.character_input').value

            slot_data[ key ] = {
                name: name,
                date: date,
                character: character
            }
        })

        return slot_data
    }
  
    function connect_datepickers()
    {
        function callback()
        {
          jQuery('div.slot_wrapper input.datepicker').each(function(){
            jQuery(this).datepicker({
              changeMonth: true,
              changeYear: true,
              minDate: new Date(1931, 1, 1), 
              maxDate: "+2Y",
              dateFormat: 'dd/mm/yy',
              yearRange: "-90:+2",
            });
          });
        }

        if (window.jQuery.fn.datepicker) {
          callback();
        } else {
          var script = document.createElement('script');
          script.src = '//code.jquery.com/ui/1.10.2/jquery-ui.js';
          script.onload = callback;
          document.getElementsByTagName('head')[0].appendChild(script);
        }


    }

}